<div class="d-flex justify-content-center" style="padding-top: 1rem" *ngIf="isInitialLoading">
  <app-loading-state></app-loading-state>
</div>
<app-confirmation-modal></app-confirmation-modal>
<div class="d-flex justify-content-center" style="padding-top: 2rem">
  <app-download-links></app-download-links>
</div>
